<template>
  <div class="s-video">
    <div class="close iconfont icon-close" @click="hide"></div>
    <van-swipe ref="videoSwi" vertical :loop="false" class="video-con" @change="onChange" :show-indicators="false">
        <van-swipe-item class="video-single" v-for="(item,index) in list">
          <div class="video-box">
            <van-loading v-if="showLoading && current == index"></van-loading>
            
            <video 
              v-if="current==index"
              :id="`${idName}${index}`" 
              :src="item.media_path.indexOf('http')>=0?item.media_path:showpath + item.media_path"  
              object-fit="contain" 
              webkit-playsinline playsinline x5-video-player-type="h5-page"
              controls
              @loadeddata="loadEnd" 
              @canplay = "videoPlay"></video>
            <video 
              v-else-if = "current - index == 1|| index-current ==1"
              :id="`${idName}${index}`" 
              :src="item.media_path.indexOf('http')>=0?item.media_path:showpath + item.media_path" 
              webkit-playsinline playsinline x5-video-player-type="h5-page"
              controls
               object-fit="contain" ></video>
            <video 
              v-else
              :id="`${idName}${index}`" 
              src="" 
              webkit-playsinline playsinline x5-video-player-type="h5-page"
               object-fit="contain" ></video>
          </div>
          <div class="video-info">
            <h3>{{item.name}}</h3>
            <fold-txt-2  v-if="item.introduce" :content="item.introduce"></fold-txt-2>
          </div>
        </van-swipe-item>
      </van-swipe>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import videoMixin from '@/mixins/videoMixin'
import FoldTxt2 from './FoldTxt2.vue'
export default {
  components: { FoldTxt2 },
  name: 'sFeature',
  mixins:[videoMixin],
  props: {show:Boolean ,newlist: Object},
  data(){
    return{
       orginList:null,
       
       idName:'feature'
    }
  },
  watch: {
    newlist: {
      handler(newv,oldv){
        console.log(newv,'==NEWV')
        if(newv){
          let arr = [];
          arr.push(newv);
          this.list = arr;
          setTimeout(() => {
              this.playCurr(0)
            }, 100);
        }else {
          this.list = [];
          this.getDetail();
        }
      },immediate:true
    }
  },
  mounted() {
    
   
  },
  methods:{
    getDetail(){
      this.$api.featureApi.getFeatureList({typeid:2}).then(res=>{
        if(res){
          if(res && res.data){
            this.showpath = res.showpath
            this.list = res.data
            /* this.orginList = res.data
            this.list = res.data.slice(0,3) */
            setTimeout(() => {
              this.playCurr(0)
            }, 100);
          }
        }
      })
    },

    

    /* onChange(index) {
      this.current = index
      // this.playCurr(index)
    }, */

    
  },
}
</script>
<style scoped lang="scss">
  

</style>